import NewOrderEvent from './NewOrderEvent'

export default {
    NewOrderEvent
}